import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import MainContent from 'components/SeasonBreak/MainContent';

export default function SeasonBreakLandingPage() {
  return (
    <BaseLayout bgBrandColor="#5F29CC" typeBtn="buttonWhite" hasPadding={false}>
      <Head>
        <title>Mind the Graph - Season Break Offer</title>

        <meta
          key="description"
          name="description"
          content="3 months - From 75 USD to 29 USD + a custom avatar of yourself. Enjoy the Season Break and Subscribe Now."
        />
        <meta
          key="og:title"
          name="og:title"
          property="og:title"
          content="Mind the Graph - Season Break Offer"
        />
        <meta
          key="og:description"
          name="og:description"
          property="og:description"
          content="3 months - From 75 USD to 29 USD + a custom avatar of yourself. Enjoy the Season Break and Subscribe Now."
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
